export default {
  name: 'extra-args',
  // note that the store gets passed in here:
  getExtraArgs: store => {
    return {};
  },
};
